import { INBOX_USERS } from '../constants/RoutingTypes';
import RoutingRuleBase from './RoutingRuleBase';
const InboxUsersRoutingRules = RoutingRuleBase({
  '@type': INBOX_USERS
}, 'InboxUsersRoutingRules');
export const buildInboxUsersRoutingRules = options => new InboxUsersRoutingRules(options);
export default InboxUsersRoutingRules;